import { SHIPPING_ADDRESS } from '../shippingAddress';

export const FORM_ID = {
  GP: 'FORM_LM_GP',
  AU: 'FORM_LM_AU',
};
export const CONFIRMATION_ID = {
  GP: 'CONFIRMATION_LM_GP',
  AU: 'CONFIRMATION_LM_AU',
};
export const CONFIRM_PATH = {
  dev: '/gp/lineas-moviles/confirmacion/',
  qa: '/order/gp/lineas-moviles/confirmacion/',
  prod: '/order/gp/lineas-moviles/confirmacion/',
};
export const CONFIRM_PATH_AU = {
  dev: '/au/lineas-moviles/confirmacion/',
  qa: '/order/au/lineas-moviles/confirmacion/',
  prod: '/order/au/lineas-moviles/confirmacion/',
};

export const URL_SEO = {
  GP: 'www.movistar.es/order/gp/lineas-moviles',
  AU: 'www.movistar.es/order/au/lineas-moviles',
};
export const PATH_NAME = {
  GP: '/order/gp/lineas-moviles/',
  AU: '/order/au/lineas-moviles/',
};
export const PHONE_900 = '900 110 619';
export const HOME_URL = 'https://www.movistar.es/tarifas-moviles/';
export const TCOL_FORM = `https://www.movistar.es/order/telco/gp/lineas-moviles/`;

export const ORION_TEXTS_IDS = {
  SHOP: 'pc-lm-no-cliente-shop',
  DIGITAL_DELIVERY: 'pc-lm-no-cliente-digital-delivery',
  SHOP_DIGITAL_DELIVERY: 'pc-lm-no-cliente-shop-digital-delivery',
  PORTABILITY: 'pc-lm-no-cliente-porta',
  MIGRATION: 'pc-lm-no-cliente-porta',
};
export const CLIENT_ORION_TEXTS_IDS = {
  SHOP: 'pc-lm-cliente-shop',
  DIGITAL_DELIVERY: 'pc-lm-cliente-digital-delivery',
  SHOP_DIGITAL_DELIVERY: 'pc-lm-cliente-shop-digital-delivery',
  PORTABILITY: 'pc-lm-cliente-porta',
  MIGRATION: 'pc-lm-cliente-action-migra',
  SHOP_SHIPMENT_DELIVERY: 'pc-lm-cliente-shop-shipment-delivery',
};
const {
  HORIZONTAL_ADDRESS,
  VERTICAL_ADDRESS,
  PROVINCE,
  POSTAL_CODE,
  ADDRESS,
  ADDRESS_DETAIL,
} = SHIPPING_ADDRESS;

export const ADDRESS_IDS = {
  GP: [
    HORIZONTAL_ADDRESS.ID,
    VERTICAL_ADDRESS.ID,
    PROVINCE.ID,
    POSTAL_CODE.ID,
    ADDRESS.ID,
    ADDRESS_DETAIL.ID,
  ],
};
export const TRANSACTION_TYPE = 'tarifas';
